import React from 'react';
import AttribTypeIcon from '../../../my-store/components/AttribTypeIcon';

export default typeEnum => {
    if (typeEnum === null) {
        return <AttribTypeIcon typeEnum={1} />;
    }

    return (
        <div className="cell" style={{ textAlign: 'left' }}>
            <AttribTypeIcon typeEnum={typeEnum} />
        </div>
    );
};
